import React from "react";
import PropTypes from "prop-types";

export function InfoComposer({ info }) {
  const compose = (sentence, f) => {
    const text = info
      .filter(f)
      .map(({ key }) => {
        return key;
      })
      .join(", ");

    return text
      ? [text, sentence.replace(new RegExp("\\$", "g"), text)]
      : ["", ""];
  };

  return (
    <div>
      {[
        compose(
          "These will not be merged over, so make sure to copy any essential data to the target client card.",
          (e) => {
            return !e.syncable;
          }
        ),
        compose(
          `Typically, these are copied over during a CRM merge operation and should already be visible 
    on the target client card. In this case, no action is required. 
    However, if you notice any missing information, please copy any important $`,
          (e) => {
            return e.syncable;
          }
        ),
      ]
        .filter(([visible]) => {
          return visible;
        })
        .map(([visible, t]) => {
          return (
            <p key={visible}>
              <b>{visible}:</b> {t}
            </p>
          );
        })}
    </div>
  );
}

InfoComposer.propTypes = {
  info: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      syncable: PropTypes.bool.isRequired,
    })
  ),
};
InfoComposer.defaultProps = { info: [] };

export default InfoComposer;
